import { useState, useEffect, useCallback, useContext } from "react";
import { Box,Grid,TextField,Typography,Button,Container,Radio,RadioGroup,FormControlLabel,FormControl,FormLabel,Paper,Divider} from "@mui/material";

import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { callPostApi } from "../../function/ApiCallFunction";
import InfoPopover from "../../components/CommanComponents/InfoPopover";
import GradientLoader from "../../components/CommanComponents/GradientLoader";
import { DataContext } from "../../context/DataContext";


export default function StoreLoyaltySetting() 
{
    const navigate = useNavigate();
    const {loginData } = useContext(DataContext);
    const store_id = loginData?.store_info?.store_id;
  
    const [loading, setLoading] = useState(false);

    const [minEarnCartAmt,   setMinEarnCartAmt]   = useState("200");
    const [minRedeemCartAmt, setMinRedeemCartAmt] = useState("100");
    const [maxPointLife,     setMaxPointLife]     = useState("1");
    const [maxRedeemPcrt,    setMaxRedeemPcrt]    = useState("1");
    const [maxPointEarn,     setMaxPointEarn]     = useState("1");    
    const [earnPointType,    setEarnPointType]    = useState("1");
    const [incrementCartAmt, setIncrementCartAmt] = useState("100");
    const [earnPoint,        setEarnPoint]        = useState("10");
    const [earnPointPcrt,    setEarnPointPcrt]    = useState("1");
    const [digitalUpiId,     setDigitalUpiId]     = useState("");
    const [welcomepoint,     setWelcomepoint]     = useState("");
    const [refBounsPoint,    setRefBounsPoint]    = useState("");    
    const [pointValue] = useState("1");

    /* -------------------- Fetch Details -------------------- */
    const getloyaltydetails = useCallback(async () =>
    {
       if (!store_id) return;
        try 
        {
            setLoading(true);
            const payload = { mod: "STORE_LOYALTY_DETAIL",data_arr: { store_id } };
            const apiResult = await callPostApi("store-detail", payload);

            if (apiResult.status === "200" && apiResult.data) 
            {
                  const item = apiResult.data.loyaltyDetail;

                  setMinEarnCartAmt(item.earn_cart_amount || "0");
                  setMinRedeemCartAmt(item.redeem_cart_amount || "0");
                  setMaxPointLife(item.point_life || "1");
                  setMaxRedeemPcrt(item.max_redeem_percentage || "0");
                  setMaxPointEarn(item.max_point_earn || "0");
                  setDigitalUpiId(item.digital_upi_id || "");
                  setEarnPointType(String(item.earn_point_type || "1"));
                  setIncrementCartAmt(item.incremental_cart_amount || "0");
                  setWelcomepoint(item.welcome_point || "0");
                  setRefBounsPoint(item.referral_bonus_point || "0");
                  setEarnPoint(item.earn_point || "0");
                  setEarnPointPcrt(item.earn_point_percent || "0");
              }
        } 
        catch (err) 
        {
          console.error(err);
          toast.error("Failed to load loyalty settings");
        } 
        finally { setLoading(false); }
    },[store_id]);

    useEffect(() => { getloyaltydetails(); }, [getloyaltydetails]);

    const handleformsave = async () => 
    {
        try 
        {
            setLoading(true);

            const payload = { mod: "UPDATE_LOYALTY",data_arr: { store_id,'earn_cart_amount': minEarnCartAmt,'redeem_cart_amount': minRedeemCartAmt,'earn_point_type': earnPointType,
                              'earn_point_percent': earnPointPcrt,'earn_point': earnPoint,'incremtCartAmount': incrementCartAmt,'max_point_earn': maxPointEarn,
                              'point_value': "1",'point_life': maxPointLife,'max_redeem_percentage': maxRedeemPcrt,'loyalty_enable': "Yes",
                              'digital_upi_id': digitalUpiId,'welcome_point': welcomepoint,'referral_bonus_point': refBounsPoint, } };

            const apiResult = await callPostApi("store-update", payload);

            if (apiResult?.status === "200") 
            {
                toast.success("Updated Successfully");
                navigate("/home");
            } 
            else { toast.error("Failed to update loyalty settings"); }
        } 
        catch (err) 
        {
            console.error(err);
            toast.error("Something went wrong while saving");
        } 
        finally { setLoading(false); }
    };

    return (
    <Container sx={{ my: 6 }}>
      {loading && <GradientLoader text="Saving Loyalty Settings..." />}

        <Box sx={{ display: 'flex', justifyContent: 'start', mb: 2 }}>
            <Button  variant="contained" sx={{ backgroundColor: '#000000', color: '#ffffff' }}  onClick={() => navigate(-1)} > Back </Button>
        </Box>

        <Typography variant="h5" sx={{ mb: 3,fontWeight: 600,color: "#0a4811",}}>Loyalty Program Settings</Typography>
 
        <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>

          <Grid  spacing={3} direction={'column'} container>
              
              <Grid item xs={12}  >
                  <TextField fullWidth label="What is minimum Order value to earn first loyalty point?" type="number" value={minEarnCartAmt} 
                      onChange={(e) => setMinEarnCartAmt(e.target.value)}/>
                  <InfoPopover title="What is minimum Order value to earn first loyalty point?" description="वह न्यूनतम ऑर्डर राशि क्या है जो आप अपने ग्राहक को एक लॉयल्टी पॉइंट अर्जित करने के लिए चाहते हैं?" />
              </Grid>

              <Grid item xs={12}>
                  <TextField fullWidth label="What is minimum Order value to apply loyalty point?" type="number" value={minRedeemCartAmt} 
                      onChange={(e) => setMinRedeemCartAmt(e.target.value)} />
                  <InfoPopover title="What is minimum Order value to apply loyalty point?" description="लॉयल्टी पॉइंट लागू करने के लिए न्यूनतम ऑर्डर मूल्य क्या है?" />      
              </Grid>

              <Grid item xs={12} md={6}>
                  <TextField fullWidth label="What is the validity of loyalty points (In Month)?" type="number" value={maxPointLife}
                      onChange={(e) => setMaxPointLife(e.target.value)} />
                  <InfoPopover title="What is the validity of loyalty points (In Month)?" description="लॉयल्टी पॉइंट की वैधता क्या होगी?" />      
              </Grid>

              <Grid item xs={12} md={6}>
                  <TextField fullWidth label="Maximum Earnable Points" type="number" value={maxPointEarn}
                      onChange={(e) => setMaxPointEarn(e.target.value)} />
                  <InfoPopover title="What is the Maximum Earnable Points?" description="" />      
              </Grid>

              <Grid item xs={12} md={6}>
                  <TextField fullWidth label="What is the maximum redeem percentage for spending loyalty points?" type="number" value={maxRedeemPcrt}
                      onChange={(e) => setMaxRedeemPcrt(e.target.value)} />
                  <InfoPopover title="What is the maximum redeem percentage for spending loyalty points?" description="लॉयल्टी पॉइंट रिडीम करने पर कटौती करने के लिए अधिकतम राशि क्या होगी?" />      
              </Grid>

              <Grid item xs={12} md={6}>
                  <FormControl fullWidth> 
                      <FormLabel sx={{ fontWeight: 600, color: "#000" }}> Earn Point Type</FormLabel>
                      <RadioGroup row value={earnPointType} onClick={(e) => setEarnPointType(e.target.value)} >
                          <FormControlLabel value="1" control={<Radio />} label="Incremental" />
                          <FormControlLabel value="2" control={<Radio />} label="Percentage" />
                      </RadioGroup>
                  </FormControl>
              </Grid>

              {/* Conditional Row (Row 4) */}
              {earnPointType === "1" ? (
                <>
                  <Grid item xs={12} md={6}>
                      <TextField fullWidth label="Additional Points per Amount Worth" type="number" 
                        value={incrementCartAmt} onChange={(e) => setIncrementCartAmt(e.target.value)} />
                  </Grid>
                  <Grid item xs={12} md={6}>
                      <TextField fullWidth label="Points to Earn" type="number" value={earnPoint} onChange={(e) => setEarnPoint(e.target.value)} />
                  </Grid>
                </>
              ) : (
                <Grid item xs={12} md={6}>
                    <TextField fullWidth label="Earn Point Percentage" type="number" value={earnPointPcrt} onChange={(e) => setEarnPointPcrt(e.target.value)} />
                </Grid>
              )}

              <Grid item xs={12} md={6}>
                <TextField fullWidth label="How Many Bonus Welcome Points Do you want to Issue to Customers on Joining Loyalty?" type="number" value={welcomepoint}
                    onChange={(e) => setWelcomepoint(e.target.value)} />
                <InfoPopover title="How Many Bonus Welcome Points Do you want to Issue to Customers on Joining Loyalty?" 
                    description="लॉयल्टी में शामिल होने पर आप ग्राहकों को कितने बोनस वेलकम पॉइंट जारी करना चाहते हैं?" /> 
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField fullWidth label="How many Referral Bonuses do you want to be Issued to referrals on the first purchase?" type="number" value={refBounsPoint}
                    onChange={(e) => setRefBounsPoint(e.target.value)} />
                <InfoPopover title="How many Referral Bonuses do you want to be Issued to referrals on the first purchase?" 
                    description="आप पहली खरीद पर रेफ़रल को कितने रेफ़रल बोनस जारी करना चाहते हैं?" /> 
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField fullWidth label="Digital UPI ID (for Payment)" value={digitalUpiId} onChange={(e) => setDigitalUpiId(e.target.value)}/>
              </Grid>

              <Grid item xs={12} md={6}>
                  <Typography variant="subtitle1" sx={{ mt: 3, color: "#1976d2", fontWeight: "bold" }} >1 Loyalty Point Value = ₹ {pointValue} </Typography>
              </Grid>
          </Grid>

          <Divider sx={{ my: 6 }} />

        <Box sx={{ textAlign: "center" }}>
                <Button variant="contained" onClick={handleformsave} sx={{ backgroundColor: "#0a4811",textTransform: "none", fontWeight: "bold",px: 5,py: 1.2,
                    "&:hover": { backgroundColor: "#0c6015" },}}>Save Settings</Button>
        </Box>

      </Paper>
    </Container>
  );
}
